module.exports = __webpack_public_path__ + "static/img/hero.a503ec5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/hero.png
// module id = k38B
// module chunks = 0